import { iamGroupOfAppUserFields } from '../iam-app-user/iam-app-user.queries';
import { iamGroupDetailFields } from '../iam-group/iam-group.queries';
import { gql } from 'graphql-tag';

const iamGroupMembershipUpdateMutationFields = `
  groupId
  appUserId
  membershipType

  member {
    id
    membershipType
  }
`;

const iamGroupMembershipMutationFields = `
  groupId
  appUserId
  membershipType

  appUser {
    id
    groups {
      ${iamGroupOfAppUserFields}
    }
  }
`;

export const addIamAppUsersToGroupMutation = gql`
  mutation addAppUsersToGroup($input: CreateGroupMembershipInput!) {
    addAppUsersToGroup(input: $input) {
      ${iamGroupDetailFields}
    }
  }
`;

export const addIamGroupToAppUsersMutation = gql`
  mutation addGroupToAppUsers($input: CreateGroupMembershipInput!) {
    addGroupToAppUsers(input: $input) {
       ${iamGroupMembershipMutationFields}
    }
  }
`;

export const updateIamGroupMembershipMutation = gql`
  mutation updateGroupMembership($input: UpdateGroupMembershipInput!) {
    updateGroupMembership(input: $input) {
      ${iamGroupMembershipUpdateMutationFields}
    }
  }
`;

export const updateIamGroupMembershipAndSetSupervisorMutation = gql`
  mutation updateGroupMembershipAndSetSupervisor($input: UpdateGroupMembershipInput!) {
    updateGroupMembershipAndSetSupervisor(input: $input) {
      ${iamGroupMembershipUpdateMutationFields}
    }
  }
`;

export const removeIamAppUsersFromGroupMutation = gql`
  mutation removeAppUsersFromGroup($input: DeleteGroupMembershipInput!) {
    removeAppUsersFromGroup(input: $input) {
      ${iamGroupDetailFields}
    }
  }
`;

export const removeIamGroupFromAppUsersMutation = gql`
  mutation removeGroupFromAppUsers($input: DeleteGroupMembershipInput!) {
    removeGroupFromAppUsers(input: $input) {
      ${iamGroupMembershipMutationFields}
    }
  }
`;
